// src/routes/ProtectedRoute.tsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth-context";

const ProtectedRoute: React.FC = () => {
  const { loading, sessao } = useAuth();
  const location = useLocation();

  // Enquanto está carregando a sessão, evita piscar/loop
  if (loading) {
    return null; // ou algum <Spinner />
  }

  // Se não tiver sessão -> manda para /entrar
  if (!sessao) {
    return (
      <Navigate
        to="/entrar"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  // Se tiver sessão -> libera as rotas filhas
  return <Outlet />;
};

export default ProtectedRoute;
